import { useNavigate } from "react-router-dom";
import { Icon } from "@/components/primitives";
import { useNotifications } from "@/hooks/useNotifications";

/**
 * Bell icon for the Profile top toolbar. Navigates to the dedicated
 * /notifications page; the unread badge stays in sync with the same
 * aggregated feed (grail matches, DMs, comments, reactions).
 *
 * Pass size="sm" for the condensed toolbar variant (28px box, 14px icon).
 * Default size="md" preserves the existing 32px / 16px live styling.
 */
interface Props {
  size?: "sm" | "md";
}

export function NotificationsBell({ size = "md" }: Props = {}) {
  const nav = useNavigate();
  const { unseenCount } = useNotifications();
  const box = size === "sm" ? 28 : 32;
  const iconPx = size === "sm" ? 14 : 16;
  const padPx = size === "sm" ? 4 : 6;

  return (
    <button
      onClick={() => nav("/notifications")}
      aria-label="Notifications"
      title="Notifications"
      style={{
        background: "none", border: "1px solid hsl(var(--ink))",
        padding: padPx, cursor: "pointer", color: "hsl(var(--ink))",
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        width: box, height: box, position: "relative",
      }}
    >
      {Icon.bell(iconPx)}
      {unseenCount > 0 && (
        <span
          aria-label={`${unseenCount} new notifications`}
          style={{
            position: "absolute", top: -6, right: -6,
            minWidth: 18, height: 18, padding: "0 4px",
            borderRadius: 999,
            background: "hsl(var(--rust))",
            color: "hsl(var(--cream))",
            border: "1.5px solid hsl(var(--ink))",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 9, fontWeight: 700,
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            lineHeight: 1,
          }}
        >
          {unseenCount > 9 ? "9+" : unseenCount}
        </span>
      )}
    </button>
  );
}